import React, {useState} from 'react';
import { Asset } from '../../../types/asset';
import { Block } from '../../other/block';
import classNames from 'classnames';

interface Bio {
  name: string;
  position: string;
  image: Asset;
  bio: string;
  linkedinUrl?: string;
  emailAddress?: string;
}

const BioItem: React.FC<{ bio: Bio, index: number, showDetailsId: number, setShowDetailsId: (id: number|false) => void}> = ({ bio, index, showDetailsId, setShowDetailsId }) => {
    const isSelected = index === showDetailsId;

    const classes = classNames({
        'bg-cover bg-center bg-no-repeat cursor-pointer': !isSelected,
        'border border-black': isSelected,
    });

    return (
      <div className={`flex items-center md:items-start flex-col mb-8 md:mb-12`} onClick={() => setShowDetailsId(isSelected ? false : index)}>
        <div className={`${classes} h-96 w-full relative px-8`} style={{ backgroundImage: isSelected ? 'none' : `url(${bio.image.url})` }}>

          <svg
            className={`${isSelected ? '' : 'transform rotate-45'} transition-transform stroke-current w-6 top-4 right-4 absolute`}
            viewBox="0 0 110 110"
            style={{
              color: isSelected ? '#000' : '#47ff47',
            }}>
            <path d="M 10,10 l 90,90 M 100,10 l -90,90" strokeWidth="5" />
          </svg>

          {(isSelected && bio.bio) && <p className={'mt-16 sm:mt-24'}>{bio.bio}</p>}

          {isSelected && bio.linkedinUrl && (
              <a className="absolute z-30 w-12 p-3 border border-black rounded-full bottom-5 sm:bottom-8" target="_blank" href={bio.linkedinUrl}>
                <svg viewBox="0 0 317.39999 303.20001">
                  <g
                    transform="translate(-524.2,-232.4)"
                    id="g123"
                  >
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      id="path119"
                      d="M 596.4,535.4 V 330.8 h -68 v 204.5 h 68 z M 562.3,303 c 23.8,0 38.5,-15.7 38.5,-35.3 -0.4,-20 -14.7,-35.3 -38.1,-35.3 -23.2,0 -38.5,15.3 -38.5,35.3 0,19.6 14.7,35.3 37.6,35.3 z"
                      className="st0"
                    />
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      id="path121"
                      d="m 634,535.4 h 68 V 421.2 c 0,-6.2 0.4,-12.3 2.3,-16.6 4.9,-12.1 16.2,-24.9 34.9,-24.9 24.7,0 34.4,18.7 34.4,46.4 v 109.5 h 68 V 418.2 c 0,-62.9 -33.6,-92.1 -78.2,-92.1 -36.8,0 -52.7,20.4 -61.7,34.4 h 0.4 v -29.8 h -68 C 634.8,350 634,535.4 634,535.4 Z"
                      className="st0"
                    />
                  </g>
                </svg>
              </a>
            )
          }
        </div>

        <div className="flex-1 mt-6 text-center md:text-left">
          <div className="text-2xl font-bold">{bio.name}</div>
          <div className="mb-1 text-2xl italic font-playfair">{bio.position}</div>
        </div>
      </div>
    );
};

interface BioProps {
  heading: string;
  bios: Bio[];
  backgroundColour?: string;
}

export const BioCollection: React.FC<BioProps> = ({ heading, bios, backgroundColour }) => {
    const [showDetailsId, setShowDetailsId] = useState(false);

    return (
      <div className={'py-20 border-black border-b'}>
          <div className={'mx-auto max-w-7xl'}>
            <h2 className="my-16 text-xl text-center uppercase">{heading}</h2>
            <div className="grid grid-cols-1 grid-rows-3 px-12 mx-auto sm:grid-cols-2 md:grid-cols-3 gap-x-24">
              {bios.map((bio, index) => (
                <BioItem
                    key={index}
                    index={index}
                    bio={bio}
                    showDetailsId={showDetailsId}
                    setShowDetailsId={setShowDetailsId}
                />
              ))}
            </div>
          </div>
      </div>
    );
};
